<template>
  <svg :width="`calc(44 / 20 * ${size})`" :height="size" viewBox="0 0 44 20" fill="none" v-on="$listeners">
    <path d="M41.7148 9.71484L1.71484 9.71484M41.7148 9.71484L32.8985 17.7148M41.7148 9.71484L32.8985 1.71484" :stroke="color" :stroke-width="stroke" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>


<script>
export default {
  name: 'IconBackward',

  props: {
    size: {
      type: String,
      default: '1em',
    },
    stroke: {
      type: [Number, String],
      default: 3.5,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>